
import apiService from './apiService';

export async function ConsultarDatosGeneracionActaAyudaHumanitaria ( {obj, token} ) {
    const url = '/consultas/ConsultarDatosGeneracionActaAyudaHumanitaria';
    return await apiService.post(url, obj, token);
};
export async function ConsultarPersonaDocumento ( {obj, token} ) {
    const url = '/caracterizacion/consultarporidentificacion';
    return await apiService.post(url, obj, token);
};
export async function ConsultarDatosRetornoFormatoCompleto ( {obj, token} ) {
    const url = '/retornos/retornoformatocompleto';
    return await apiService.post(url, obj, token);
};

